<template>
  <div id="app">
    <div class="mpt_loader" :style="{ display: isLoaded ? 'none' : 'block' }">
      <div class="mpt_loader_container">
        <div class="mpt_loader_spinner"></div>
      </div>
    </div>
    <transition-group name="slide-fade">
      <template v-if="true">
        <router-view key="mpt"></router-view>
      </template>
    </transition-group>
    <transition-group name="slide-fade">
      <template v-if="false">
        <AgeGate key="agegate" />
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import AgeGate from "@/containers/AgeGatem";

export default {
  name: "app",
  components: {
    AgeGate,
  },
  data() {
    return {
      toggler: false,
    };
  },
  computed: {
    ...mapGetters(["getAgeGateToken", "isLoaded"]),
  },
  methods: {
    ...mapActions({
      setScrollMotionAction: "setScrollMotion",
      setEdgeScrollingAction: "setEdgeScrolling",
      resetEdgeScrollingAction: "resetEdgeScrolling",
      setLoadStatus: "setLoadStatus",
      setAgeGateTokenAction: "setAgeGateToken",
    }),
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.setScrollMotionAction("downEnd");
      } else if (scrollTop + clientHeight <= clientHeight + 5) {
        this.setScrollMotionAction("upStart");
      } else {
        this.setScrollMotionAction("scrolling");
      }
    },
  },
  mounted() {
    // window.onload = () => {
    //   this.setLoadStatus()
    // }
    document.addEventListener("readystatechange", (event) => {
      this.setLoadStatus()
    });
    this.$nextTick(() => { });
  },
};
</script>

<style lang="scss">
@import "./styles/main.scss";

.mpt_loader {
  background: linear-gradient(180deg,
  #0a0e11 0,
  #0a0e11 100%);
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  height: 100%;
  height: 100vh;
  width: 100%;
  width: 100vw;
  overflow: hidden;
  z-index: 100000000000;
  .mpt_loader_container {
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    .mpt_loader_spinner {
      border: 8px solid transparent;
      border-top: 8px solid white;
      border-bottom: 8px solid white;
      border-radius: 50%;
      width: 120px;
      height: 120px;
      animation: spin 2s linear infinite;
    }
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
